import React from 'react'

function ViewMembershipCategory({ service, closeModal }) {
    if (!service) return null;
    function formatDateTime(isoString) {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
    
        return `${day}/${month}/${year}`;
      }
    const url = 'uploads/'
    const { date, time } = formatDateTime(service?.createdAt);
    return (
        <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true" >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="manufacturerModal">Details</h5>
                        <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body px-5">
                        <div className="d-box mt-3 pt-1">
                            {/* <h3 className="service-heading" style={{ marginBottom: '10px' }}>About</h3> */}
                            <ul className="d-flex list-unstyled justify-content-between">
                                <li><span>Name: </span>{service?.name}</li>
                                <li><span>Status: </span> {service?.status}</li>
                                <li><span>Description: </span> {service?.description}</li> 
                                <li><span>Date: </span> {formatDateTime(service?.createdAt)}</li> 
                            </ul>


                
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewMembershipCategory